import { Drawer } from '@mui/material';
import React from 'react';

import { LAYOUT_CONSTANTS } from '../constants/layout-constants';
import { useLayoutCalculations } from '../hooks/use-layout-calculations';
import DesktopSidebar from './desktop-sidebar';

export type SidebarDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

/**
 * Sidebar Drawer Component
 * Contains the sidebar with responsive behavior and proper styling
 */
const SidebarDrawer = ({ isOpen, onClose }: SidebarDrawerProps) => {
  const { isDesktop, isTablet, isMobile, getSidebarDrawerWidth } = useLayoutCalculations();

  return (
    <Drawer
      variant={isDesktop ? 'persistent' : 'temporary'}
      anchor="left"
      open={isOpen}
      onClose={isDesktop ? undefined : onClose} // Only allow close on mobile
      sx={{
        width: getSidebarDrawerWidth(),
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: getSidebarDrawerWidth(),
          boxSizing: 'border-box',
          backgroundColor: 'var(--sub-bg-color)',
          borderRight: '1px solid',
          borderRightColor: 'divider',
          // Enhanced mobile experience
          ...(isMobile && {
            width: '85vw',
            maxWidth: LAYOUT_CONSTANTS.DRAWER_WIDTH_MOBILE
          }),
          // Tablet optimization
          ...(isTablet && {
            width: '60vw',
            maxWidth: LAYOUT_CONSTANTS.DRAWER_WIDTH
          })
        }
      }}
      ModalProps={{
        keepMounted: true // Better open performance on mobile
      }}
    >
      <DesktopSidebar />
    </Drawer>
  );
};

export default SidebarDrawer;
